import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function UsersGraph({ data }) {
	const id = 'users-graph';

	useEffect(() => {
		if (!data || !data.length) {
			return;
		}
		const element = document.getElementById(id);

		if (!element) {
			return;
		}
		const options = getChartOption(data);
		const chartUser = new ApexCharts(element, options);
		chartUser.render();

		return function cleanUp() {
			chartUser.destroy();
		};
	}, [data]);

	return <div id={id}></div>;
}

function getChartOption(data) {
	const preOptions = chartOptions(data);
	preOptions.yaxis = {
		...preOptions.yaxis,
		labels: {
			formatter: (v) => parseInt(v),
		},
	};
	const usersData = data.map((d) => {
		return {
			...d.metrics.Users, ts: d.ts
		}
	}
	);
	if (!usersData || !usersData.length) {
		return;
	}
	const options = {
		series: [
			{
				name: 'New Signed Users',
				data: usersData.map((entry) => entry?.new?.signed || 0),
			},
			{
				name: 'New Guest Users',
				data: usersData.map((entry) => entry?.new?.guest + entry?.new?.guestWithName || 0),
			},
		],
		colors: ['#835FC2', '#FE6F5E', '#FFC75F', '#D55DB1'],
		...preOptions,
	};
	return options;
}
